import { useState } from 'react';

import {
  getIsMobileViewport,
  isApplicationCompleteDE,
  isMobileSignupPreviewEnabled,
  isPreAccountStepDE,
} from './eligibility';
import { SPLIT_TEST_NAME } from '../../AnonymousSplitTest/SPLIT_TESTS';
import { useAnonymousSplitTests } from '../../AnonymousSplitTest/useAnonymousSplitTests';
import {
  useGetApplicationQuery,
  useGetStateQuery,
} from '../../api/lendingApi/lendingApiQueries';
import { useCurrentStep } from '../../hooks/useCurrentStep';
import { useSignup } from '../../hooks/useSignup';
import { useSignupParams } from '../../hooks/useSignupParams';
import { TGetStateResponseDE } from '../../lapiOverrideTypesDE';
import { SignupLayout } from '../Layout/SignupLayout/SignupLayout';
import MobileSignupContainerDE from '../MobileSignup/MobileSignupContainerDE';
import RouteSpinner from '../RouteSpinner/RouteSpinner';
import SignupRoutesDE from '../SignupRoutes/SignupRoutesDE/SignupRoutesDE';
import StepRouterDE from '../StepRouter/StepRouterDE/StepRouterDE';

const SignupContainerDE = () => {
  const [isMobile] = useState(getIsMobileViewport);

  const { isDirectCustomer } = useSignupParams();
  const canEnterSplitTest =
    isMobileSignupPreviewEnabled() && isDirectCustomer && isMobile;
  const splitTests = useAnonymousSplitTests({
    testFilter: SPLIT_TEST_NAME.DE_MOBILE_SIGNUP_V1,
    enabled: canEnterSplitTest,
  });
  const isIncludeBranch =
    splitTests?.some((test) => test.branch_name === 'INCLUDE') ?? false;
  const isEligible = isIncludeBranch && canEnterSplitTest;

  const { isLoading, hasAllData } = useSignup();
  const { state } = useGetStateQuery<TGetStateResponseDE>();
  const { application } = useGetApplicationQuery();
  const currentStep = useCurrentStep();

  const legacyFlow = (
    <SignupLayout>
      <StepRouterDE>
        <SignupRoutesDE />
      </StepRouterDE>
    </SignupLayout>
  );

  if (!isEligible) {
    return legacyFlow;
  }

  if (isLoading || !hasAllData) {
    return isPreAccountStepDE(currentStep) ? (
      <MobileSignupContainerDE />
    ) : (
      <RouteSpinner />
    );
  }

  if (isApplicationCompleteDE(state, application)) {
    return legacyFlow;
  }

  return <MobileSignupContainerDE />;
};

export default SignupContainerDE;
